// PURA: el avance de pasos de la confirmación de la tienda online (confirmación v2).
//
// Reutiliza `buildSteps` (la misma línea de tiempo que /p/<código>) y la recorta
// a lo que cabe en la tarjeta principal:
//   recogida  → Recibida · En cocina · Lista
//   domicilio → Recibida · En cocina · Lista · En camino · Entregada
// En recogida "entregado" (el cliente ya lo recogió) no es un paso aparte: deja
// "Lista" hecho. Sin snapshot (no hubo código de recibo, o el primer sondeo no
// llegó) el avance se queda en "Recibida" — nunca inventa un estado.
import { buildSteps, type StepKey, type TimelineStep } from "./steps"
import type { TrackingSnapshot } from "./types"

export type ProgressStep = { key: StepKey; status: TimelineStep["status"] }

export function confirmProgress(snapshot: TrackingSnapshot | null, isDelivery: boolean): ProgressStep[] {
  const keys: StepKey[] = isDelivery
    ? ["recibido", "en_cocina", "listo", "en_camino", "entregado"]
    : ["recibido", "en_cocina", "listo"]

  if (!snapshot) {
    return keys.map((key, i) => ({ key, status: i === 0 ? "current" : "todo" }))
  }
  if (snapshot.state === "cancelado") {
    return [
      { key: "recibido", status: "done" },
      { key: "cancelado", status: "current" },
    ]
  }
  if (!isDelivery && snapshot.state === "entregado") {
    return keys.map((key) => ({ key, status: "done" }))
  }
  const byKey = new Map(buildSteps(snapshot).map((s) => [s.key, s.status]))
  return keys.map((key) => ({ key, status: byKey.get(key) ?? "todo" }))
}
